import { mtop } from '../../utils';
import { message } from 'antd';
import { delay } from 'redux-saga';

export default {
  namespace: 'loanList',
  state: {
    billList: {},
    projectNameList: [],
    billDetail: {},
  },

  reducers: {
    setBillList(state, { payload: billList = {} }) {
      return {
        ...state,
        billList,
      };
    },
    setProjectNameList(state, { payload: projectNameList = [] }) {
      return {
        ...state,
        projectNameList,
      };
    },
    setBillDetail(state, { payload: billDetail }) {
      return {
        ...state,
        billDetail,
      };
    },
  },
  effects: {
    // 收款记录里列表
    *getBillList({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.projectloan.list', {
          ...payload,
        });
        yield put({ type: 'setBillList', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setBillList', payload: {} });
      }
    },
    // 项目名称列表
    *getProjectNameList({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.project.name.get', {
          ...payload,
        });
        yield put({ type: 'setProjectNameList', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setProjectNameList', payload: {} });
      }
    },
    // 提前收款详情
    *getBillDetail({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.projectloan.detail', {
          ...payload,
        });
        yield put({ type: 'setBillDetail', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setBillDetail', payload: { err: true } });
      }
    },

    // 获取发票信息
    *getInvoiceInfo({ payload }, { call }) {
      try {
        const response = yield call(mtop, 'loan.invoiceinfo.get', {
          ...payload,
        });

        return response;
      } catch (error) {
        message.error(error.msg);

        return { error: true }
      }
    },

    // 保存快递信息
    *saveInvoiceExpressInfo({ payload }, { call }) {
      try {
        const response = yield call(mtop, 'loan.invoiceexpressinfo.save', {
          ...payload,
        });

        yield call(message.success, '发票单号已提交');

        return response;
      } catch (error) {
        message.error(error.msg);

        return { error: true };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/proceed/loanList.js